import React from "react";
import { NavLink } from "react-router-dom";

const Profiletabs = () => {
  const Tabs = [
    { name: "Account", link: "/account" },
    // { name: "General", link: "/general" },
    { name: "Profile", link: "/profile" },
    { name: "Bank", link: "/bank" },
    { name: "Security", link: "/security" },
    { name: "Session", link: "/session" },
  ];
  return (
    <div className="settings-menu">
      {Tabs.map((e) => (
        <NavLink to={e.link}>{e.name}</NavLink>
      ))}
    </div>
  );
};

export default Profiletabs;
